import initialstate from '../../initialstate';
import {HttpStatusCodes} from '../../../util/uiconstants';
import {
	DELETE_GACOMPONENT_ACCOUNT,
	GET_ALL_ACCOUNTS,
	POST_GACOMPONENT_ACCOUNT,
	SET_ACCOUNTS_PARAMETERS
} from '../../../actions/actiontypes';
import normalizeAccounts from './normalizeAccounts';
import normalizeComponentAssociations from './normalizeComponentAssociations';
import normalizeComponentDeassociation from './normalizeComponentDeassociation';

export default function groupAccountsReducer(state = initialstate.groupAudit.accounts, action) {
	switch (action.type) {
		case GET_ALL_ACCOUNTS: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				const parameters = {
					...state.parameters,
					pages: action?.response?.pages === 0 ? 1 : action?.response?.pages,
					page: action?.response?.page,
					totalEntityCount: action?.response?.totalEntityCount
				};

				if (action?.config?.searchString) parameters.searchString = action?.config?.searchString;
				if (action?.config?.pageSize) parameters.pageSize = action?.config?.pageSize;

				return {
					data: normalizeAccounts(action?.response?.data),
					parameters
				};
			}

			return state;
		}
		case SET_ACCOUNTS_PARAMETERS: {
			if (action.payload) {
				return {
					...state,
					parameters: {
						...state.parameters,
						...action?.payload
					}
				};
			}
			return state;
		}
		case POST_GACOMPONENT_ACCOUNT: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				const accountId = action?.response?.id;
				const componentIds = action?.response?.gaComponentId;
				return {...state, data: normalizeComponentAssociations(state.data, componentIds, accountId)};
			}
			return state;
		}
		case DELETE_GACOMPONENT_ACCOUNT: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				const accountId = action?.accountId;
				const componentId = action?.componentId;
				return {...state, data: normalizeComponentDeassociation(state.data, componentId, accountId)};
			}
			return state;
		}
		default:
			return state;
	}
}
